import {
  BaseRecord,
  HttpError,
  IResourceComponentsProps,
} from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import { Select, Textarea } from "@mantine/core";
import { CreateComment } from "entities/comment";
import UserSelect from "components/users/UserSelect";
import ArticleSelect from "components/articles/ArticleSelect";
import { isNotEmpty } from "@mantine/form";
import { selectCommentableTypes } from "entities/comment/commentable_type";
import CommentSelect from "./CommentSelect";
import ImageDropZone from "components/common/ImageDropZone";
import PollSelect from "components/polls/PollSelect";

export const CommentEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    getInputProps,
    saveButtonProps,
    setFieldValue,
    values,
    refineCore: { queryResult },
  } = useForm<BaseRecord, HttpError, CreateComment>({
    refineCoreProps: {
      redirect: "show",
    },
    initialValues: {
      id: undefined,
      body: "",
      commentable_id: undefined,
      commentable_type: "WordpressArticle",
      commentable: undefined,
      user: undefined,
      parent_comment_id: undefined,
      image: undefined,
    },
    validate: {
      user: isNotEmpty(),
      commentable_id: isNotEmpty(),
      body: isNotEmpty(),
    },
  });

  const user = queryResult?.data?.data?.user;
  const commentable = queryResult?.data?.data?.commentable;

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <ImageDropZone
        onFileChosen={(data) => setFieldValue("image", data)}
        label="Image"
        title="Drop an image here"
        description="This is an optional image"
        maxSize={5 * 1024 ** 2} // 5mb
        {...getInputProps("image")}
        value={values.image}
      />
      <CommentSelect
        label="Parent comment"
        excludeId={values.id}
        value={values.parent_comment_id}
        onChange={(comment_id) =>
          setFieldValue("parent_comment_id", comment_id)
        }
      />
      <UserSelect
        defaultValue={user?.id}
        value={values.user_id}
        onChange={(userId) => setFieldValue("user_id", userId)}
      />
      <Select
        placeholder="Channel"
        data={selectCommentableTypes}
        label="Commentable Type"
        clearable={false}
        {...getInputProps("commentable_type")}
      />
      {commentable && values.commentable_type === "WordpressArticle" && (
        <ArticleSelect
          label="Article to comment on"
          defaultValue={commentable.id}
          value={values.commentable_id}
          onChange={(articleId) => setFieldValue("commentable_id", articleId)}
        />
      )}
      {commentable && values.commentable_type === "Poll" && (
        <PollSelect
          label="Poll to comment on"
          value={values.commentable_id}
          onChange={(pollId) => setFieldValue("commentable_id", pollId)}
        />
      )}
      <Textarea label="Body" {...getInputProps("body")} />
    </Edit>
  );
};
